import { ErrorHandler, Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PlusException, PlusAlertsService} from 'components'
import { ServiceLocator } from './ServiceLocator';
import { NgxSpinnerService } from 'ngx-spinner';



@Injectable({
  providedIn: 'root'
})
export class ErrorService implements ErrorHandler {
  private get notServ() { return ServiceLocator.injector.get(ToastrService) };//LAzy load prevent error on constructor
  private get spinner() { return ServiceLocator.injector.get(NgxSpinnerService) };//LAzy load prevent error on constructor
  private get plusAlertsService() { return ServiceLocator.injector.get(PlusAlertsService) };//LAzy load prevent error on constructor

  handleError(ex) {
    // your custom error handling logic   
    console.error(ex);
    if (ex instanceof PlusException || ex.message.indexOf('PlusException') > 0) {
      //this.notServ.error(ex.description, 'Error');
      let exJson = /\{.+\}/g.exec(ex.message);

      if (!exJson)

        this.plusAlertsService.setCtDialogInfo('Error', 'downloadError', 'downloadError', 'primary', ex.description,
          true, 'De acuerdo', 'Cancelar');

      else

        this.plusAlertsService.setCtDialogInfo('Error', 'downloadError', 'downloadError', 'primary', JSON.parse(exJson.pop()).description,
          true, 'De acuerdo', 'Cancelar');
    }
    else if (ex.message)
      //this.notServ.error(ex.message, 'Error');
      this.plusAlertsService.setCtDialogInfo('Error', 'downloadError', 'downloadError', 'primary', ex.message,
        true, 'De acuerdo', 'Cancelar');
    else
      //this.notServ.error(new PlusException().description, 'Error');
      this.plusAlertsService.setCtDialogInfo('Error', 'downloadError', 'downloadError', 'primary', new PlusException().description,
        true, 'De acuerdo', 'Cancelar');
  }

  handleUIError(ex) {
    this.spinner.hide()
    this.handleError(ex)
  }

  error(ex: PlusException) {
    //this.notServ.error('Error', ex.description);
    this.plusAlertsService.setCtDialogInfo('Error', 'downloadError', 'downloadError', 'primary', ex.description,
      true, 'De acuerdo', 'Cancelar');
  }

  getResMsg(error) {
    error = error?.error ? error.error : error;
    let errorMsg = (error.ResponseMessages && error.ResponseMessages.length > 0 ? error.ResponseMessages[0].Message : error.description) || null

    return errorMsg
  }

  getResMsgCode(error) {
    error = error?.error ? error.error : error;
    let errorMsg = (error.ResponseMessages && error.ResponseMessages.length > 0 ? error.ResponseMessages[0].Message : error.description) || null

    return errorMsg
  }
}
